'use client';

import React from 'react';
import Image from 'next/image';
import CodeLogin from '@/components/login/CodeLogin';
import WechatLogin from '@/components/login/WechatLogin';
import { LOGIN_CONTENT } from '@/constants/auth';
import starImage from '@/assets/login/star.png';
import backgroundImage from '@/assets/login/bg.png';
const LoginPage = () => {
  const [isCodeLogin, setIsCodeLogin] = React.useState(false);
  const [loginContent, setLoginContent] = React.useState('');

  React.useEffect(() => {
    const content = sessionStorage.getItem(LOGIN_CONTENT);
    if (content) {
      setLoginContent(content);
      sessionStorage.removeItem(LOGIN_CONTENT);
    }
  }, []);

  return (
    <div
      className="w-full h-full flex flex-col items-center justify-center"
      style={{
        background: `url(${backgroundImage.src}) no-repeat 50% calc(50vh - 200px)/cover border-box`,
      }}
    >
      {loginContent ? (
        <p className="mb-10 font-semibold tablet:text-2xl">{loginContent}</p>
      ) : (
        <div className="w-25 h-16.5 relative mb-10 tablet:w-36 tablet:h-27">
          <Image
            src={starImage}
            alt=""
            fill
            style={{
              objectFit: 'contain',
            }}
          />
        </div>
      )}
      <div className="bg-white flex flex-col px-6 py-10 rounded-2.5xl max-w-[400px] min-w-[240px] shadow-[0px_40px_80px_0px_rgba(0,0,0,0.05)] z-10 tablet:max-w-auto tablet:w-[480px] tablet:px-10">
        <div className={isCodeLogin ? 'block' : 'hidden'}>
          <CodeLogin
            headerTitle="验证码登录/注册"
            setIsCodeLogin={setIsCodeLogin}
          />
        </div>
        {!isCodeLogin && <WechatLogin setIsCodeLogin={setIsCodeLogin} />}
      </div>
    </div>
  );
};

export default LoginPage;
